//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wxPay from "@/common/js/wxPay.js"
import moment from 'dayjs'
import calendarPage from '@/components/calendarPage/calendarpage.vue'
import couponLine from '@/components/coupon/index.vue'
import uniNumberBox from "@/components/uni-number-box/uni-number-box.vue"
import paymentSelect from '@/components/paymentSelect/index.vue'
export default {
	mixins: [wxPay],
	components: {
		calendarPage,
		couponLine,
		uniNumberBox,
		paymentSelect
	},
	data() {
		return {
			color: '#FF6603',
			//日历
			dateList: {
				info: {
					checkInDate: '',
					checkOutDate: ''
				},
				startText: '',
				pattern: 'single',
				range: [], //日期范围
				show: false, //日历展示 
				close: false //日历动画
			},
			coupons: [],
			//内容
			list: {},
			salePrice: 0, //成人价格
			childPrice: 0, //儿童价格
			stock: 0, //库存
			date: '', //日期
			id: '', //路由产品id
			noUse: true, //日期选择按钮展示
			forms: {
				saleNum: 1, //成人数量
				childrenNum: 0, //儿童数量
				startOffDate: '', // 出游日期，必填yyyy-MM-dd
				couponPrice: 0, //优惠券价格
				originalPrice: 0, // 总价，必填
				payPrice: 0, // 实际支付金额，必填
				reserveName: '', // 预留人姓名，必填
				reserveMobile: '', // 预留的手机号码，必填
				reserveCode: '', // 预留的身份证，必填
				storeId: '1', // 店铺id，必填
				barCode: '', // 优惠券券码
				memberId: '', // 会员的id，必填
				productId: ''
			},
			productTypeCode: '', //产品来源code
			advanceDate: '', //提前预定天数
			//预留信息判断
			isNameError: false,
			isPhoneError: false,
			isIDError: false,
			orderId: '', //预订id
			submitLoading: false, //预订按钮
			showPaymentSelect: false,
			countPrice: 0, //折扣金额
			couponCode: '', //优惠券id
			isSellingChild: '', //是否售卖儿童
			orderType: 'route' //预订类型
		}
	},
	onLoad(event) {
		this.date = event.date
		this.dateList.info.checkInDate = event.date
		this.forms.saleNum = parseInt(event.saleNum)
		this.forms.childrenNum = parseInt(event.childrenNum)
		this.id = event.id
		this.productTypeCode = event.productTypeCode
		this.init()
	},
	onShow() {
		this.forms.memberId = this.$store.state.userInfo.memberId
		// if(this.forms.memberId){
		this.queryData()
		this.queryWeChatLineData(this.dateList.info)
		this.selectDate()
		// }
	},
	computed: {
		childTotlePrice() {
			return parseFloat(this.childPrice * this.forms.childrenNum)
		},
		originalPrice() {
			return parseFloat(this.salePrice * this.forms.saleNum + this.childPrice * this.forms.childrenNum).toFixed(2)
		},
		price() {
			let price = this.countPrice > 0 ? parseFloat(this.originalPrice - this.countPrice).toFixed(2) : parseFloat(this.originalPrice)
				.toFixed(2)
			return price <= 0 ? 0.01 : price
		},
		saleStock() {
			let usedStock = this.forms.childrenNum
			let residue = this.stock - usedStock
			let saleStock = residue <= 0 ? 0 : residue
			return saleStock
		},
		childStock() {
			let usedStock = this.forms.saleNum
			let residue = this.stock - usedStock
			let childStock = residue <= 0 ? 0 : residue
			return childStock
		}
	},
	methods: {
		handelClose() {
			this.showPaymentSelect = false
			this.submitLoading = false
		},
		activeDay(val) {
			this.salePrice = val.date.saleSettlementPrice
			this.childPrice = val.date.childSettlementPrice
		},
		reserveName(e) {
			this.forms.reserveName = e.target.value
		},
		reserveMobile(e) {
			this.forms.reserveMobile = e.target.value
		},
		reserveCode(e) {
			this.forms.reserveCode = e.target.value
		},
		renderCoupon(data) {
			return data.map(t => {
				return {
					...t,
					id: t.childCouponCode,
					oringinId: t.id,
					available: 1,
					useType: t.useType,
					discount: 0,
					denominations: t.couponDenomination,
					origin_condition: t.useDoorsill === 0 || t.useDoorsill === null ? '无使用门槛' : `满${t.useDoorsill}减${t.couponDenomination}`,
					reason: '',
					value: t.useDoorsill
				}
			})
		},
		testName() {
			return !!this.forms.reserveName && /^[\u4E00-\u9FA5A-Za-z]+$/.test(this.forms.reserveName)
		},
		testPhone() {
			return /^1[345789]\d{9}$/.test(this.forms.reserveMobile)
		},
		testID() {
			return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.forms.reserveCode)
		},
		//成人数量
		saleChange(val) {
			this.forms.saleNum = val
		},
		//儿童数量
		childrenChange(val) {
			this.forms.childrenNum = val
		},
		// 获取线路信息
		init() {
			this.$ajax({
				method: 'post',
				url: '/weChat/lineOrder/queryProductByProductId',
				data: {
					productId: this.id
				}
			}).then(res => {
				this.noUse = false
				this.list = res.data
				this.forms.productId = res.data.productId
				this.advanceDay()
			})
		},
		//提前预订时间
		advanceDay() {
			if (this.list.advanceTime !== '') {
				let detailAdvanceTime = this.list.advanceTime.split(':')
				let time = {
					day: moment().add(this.list.advanceDays, 'days').format('DD'),
					hour: detailAdvanceTime[0],
					minute: detailAdvanceTime[1],
					second: detailAdvanceTime[2]
				}
				let advanceTime = moment({
					day: time.day,
					hour: time.hour,
					minute: time.minute,
					second: time.second
				}).format('YYYY-MM-DD HH:mm:ss')
				let advanceDays = moment().add(this.list.advanceDays, 'days').format('YYYY-MM-DD HH:mm:ss')
				this.advanceDate = new Date(advanceTime.replace(/-/gm, '/')) > new Date(advanceDays.replace(/-/gm, '/')) ? this.list
					.advanceDays : this.list.advanceDays + 1
			} else {
				this.advanceDate = this.list.advanceDays
			}
		},
		// 根据日期获取线路价格与事件
		queryWeChatLineData(date) {
			if (date !== undefined) {
				this.dateList.info.checkInDate = moment(new Date(date.checkInDate.replace(/-/gm, '/'))).format('YYYY-M-D')
			}
			this.$ajax({
				method: 'post',
				url: '/weChat/lineOrder/queryDayStateByDateRange',
				data: {
					memberId: this.forms.memberId || '',
					productId: this.id,
					productTypeCode: this.productTypeCode,
					beginDate: date === undefined ? moment().format('YYYY-MM-DD') : moment(new Date(date.checkInDate.replace(/-/gm,
						'/'))).format('YYYY-MM-DD'),
					endDate: date === undefined ? moment().format('YYYY-MM-DD') : moment(new Date(date.checkInDate.replace(/-/gm,
						'/'))).format('YYYY-MM-DD')
				}
			}).then(res => {
				if (res.data.data.length !== 0) {
					this.salePrice = res.data.data[0].saleSettlementPrice
					this.childPrice = res.data.data[0].childSettlementPrice
					this.stock = res.data.data[0].stock
					this.isSellingChild = res.data.isSellingChild
					this.date = moment(new Date(res.data.data[0].date.replace(/-/gm, '/'))).format('YYYY-MM-DD')
					this.dateList.close = true
					setTimeout(() => {
						this.dateList.show = false
					}, 300)
				}
			})
		},
		// 选择优惠券的回调函数,count是折扣金额，id是优惠券id
		changePrice(msg) {
			this.countPrice = msg.couponDenomination
			this.couponCode = msg.childCouponCode
		},
		// 日期范围获取
		selectDate() {
			let beginDate = new Date()
			let endDate = beginDate.setMonth(beginDate.getMonth() + 12)
			this.$ajax({
				method: 'post',
				url: '/weChat/lineOrder/queryDayStateByDateRange',
				data: {
					memberId: this.forms.memberId || '',
					productId: this.id,
					productTypeCode: this.productTypeCode,
					beginDate: moment().add(this.advanceDate, 'days').format('YYYY-MM-DD'),
					endDate: moment(endDate).format('YYYY-MM-DD')
				}
			}).then(res => {
				this.dateList.range = res.data.data
				this.dateList.info.defaultOpenDate = this.dateList.info.checkInDate
			})
		},
		// 获取个人信息
		queryData() {
			if (this.forms.memberId) {
				this.$ajax({
					method: 'post',
					url: '/weChat/member/queryById',
					data: {
						memberId: this.forms.memberId || ''
					}
				}).then(res => {
					this.forms.reserveMobile = res.data.phone
					this.forms.reserveName = res.data.memberName
					this.forms.reserveCode = res.data.idCard
				})
			}
		},
		// 弹出日历弹框
		handleTimeClick() {
			if (!this.noUse) {
				this.dateList.close = false
				this.dateList.show = true
			}
		},
		// 日历关闭
		handelClose() {
			this.dateList.close = true
			setTimeout(() => {
				this.dateList.show = false
			}, 300)
		},
		// inputNumber 改变
		changeNumber(num) {
			setTimeout(() => {
				this.forms.number = parseInt(num) || 0
			}, 10)
		},
		//预订提交
		onSubmit() {
			if (!this.noUse) {
				this.isNameError = !this.testName()
				this.isPhoneError = !this.testPhone()
				this.isIDError = !this.testID()
				this.forms.childrenNum = this.childPrice === 0 ? 0 : this.forms.childrenNum
				if ((this.forms.saleNum + this.forms.childrenNum) > this.stock) {
					uni.showToast({
						title: '购买数量不能大于库存！',
						icon: 'none'
					})
					return false
				}
				if (!this.isNameError && !this.isPhoneError && !this.isIDError) {
					if (this.submitLoading) {
						return false
					}
					this.submitLoading = true
					let obj = {
						memberId: this.forms.memberId || '',
						productName: this.list.productName,
						productId: this.id,
						adultQuantity: this.forms.saleNum,
						childQuantity: this.forms.childrenNum,
						isDiscount: this.couponCode ? 1 : 0, // * 是否使用优惠券 * 0：否 * 1：是
						payPrice: this.price, // 实付总价
						orderName: this.forms.reserveName,
						orderPhone: this.forms.reserveMobile,
						idCard: this.forms.reserveCode,
						couponCode: this.couponCode || '', // 优惠券ID
						useDate: this.date.replace(/-/gm, '/')
					}
					this.$ajax({
						method: 'post',
						url: '/weChat/lineOrder/orderLine',
						isForms: true,
						data: obj
					}).then(res => {
						this.orderId = res.data
						this.showPaymentSelect = true
						this.submitLoading = false
					})
				}
			}
		}
	}
}
